/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { IDateService } from '@master/services/IDateService'
import { namespace } from 'vuex-class'
import { ClientDto } from '@core/pages/client-management/api'

const clientInfoStore = namespace('ClientInfoStore')

@Component({})
export class AIOICKAMixin extends Vue {
  @inject()
  protected dateService: IDateService

  @inject()
  protected $api: API

  @clientInfoStore.State
  private clientDto: ClientDto

  @clientInfoStore.State
  private readOnly

  formattedDate (unixTime: number | string) {
    return this.dateService.format(Number(unixTime), 'YYYY-MM-DD')
  }

  get curUser () {
    return this.$store.getters.currentUser
  }

  get isSuperUser () {
    return this.curUser?.isSuperUser || false
  }

  get policyOid () {
    return this.$route.params.policyOid
  }

  get clientOid () {
    return this.$route.params.clientOid
  }
}
